interface MetaTag {
  name: string
  content: string
}

interface LinkTag {
  rel: string
  href: string
  as?: string
  crossOrigin?: string
  fetchPriority?: 'high' | 'low' | 'auto'
}

/**
 * MOCKUP OFICIAL del producto. Es el elemento LCP del hero y se reutiliza en la
 * sección de oferta. No aplicar filtros ni textos encima.
 */
export const HERO_IMAGE_URL =
  'https://cdn.magicpatterns.com/uploads/wC1wSbeoxZzc7pkF9KvZhM/MOCKUP_FINALLL.png'

/** Manos armando una caja de postres en una cocina luminosa (cierre). */
export const AUDIENCE_IMAGE_URL =
  'https://cdn.magicpatterns.com/patterns/generated-images/69f8e013-b4f5-481e-9507-885de689655b.jpg'

/** Surtido de postres (sección de las 100 recetas). */
export const RECIPES_IMAGE_URL =
  'https://cdn.magicpatterns.com/patterns/generated-images/2f59e8e1-7999-4ca9-8e0e-bc358179b8d0.jpg'

/** La sección de oferta muestra el mockup oficial del producto. */
export const BUNDLE_IMAGE_URL = HERO_IMAGE_URL

const PAGE_TITLE = 'Postres que Venden™ — 100 recetas rentables para vender desde tu cocina'

const META_TAGS: MetaTag[] = [
  {
    name: 'description',
    content:
      'Postres que Venden™: 100 recetas rentables, más de 160 páginas y el Método M.V.P.™ para elegir tus primeras 5 recetas, calcular precios y empezar a vender postres desde tu propia cocina. Incluye 5 bonos.',
  },
]

const LINK_TAGS: LinkTag[] = [
  // Warm up the font + image origins before the CSS/image requests are made.
  { rel: 'preconnect', href: 'https://fonts.googleapis.com' },
  { rel: 'preconnect', href: 'https://fonts.gstatic.com', crossOrigin: 'anonymous' },
  { rel: 'preconnect', href: 'https://cdn.magicpatterns.com' },
  // Discover the LCP image as early as possible, at high priority.
  { rel: 'preload', href: HERO_IMAGE_URL, as: 'image', fetchPriority: 'high' },
]

/**
 * Inserts global <meta> and resource-hint <link> tags into <head> once.
 * Existing tags are never duplicated.
 */
export function initHeadMeta(): void {
  if (typeof document === 'undefined') return

  document.title = PAGE_TITLE

  META_TAGS.forEach(({ name, content }) => {
    if (document.querySelector(`meta[name="${name}"]`)) return

    const meta = document.createElement('meta')
    meta.name = name
    meta.content = content
    document.head.appendChild(meta)
  })

  LINK_TAGS.forEach(({ rel, href, as, crossOrigin, fetchPriority }) => {
    if (document.querySelector(`link[rel="${rel}"][href="${href}"]`)) return

    const link = document.createElement('link')
    link.rel = rel
    link.href = href
    if (as) link.as = as
    if (crossOrigin) link.crossOrigin = crossOrigin
    if (fetchPriority) link.setAttribute('fetchpriority', fetchPriority)
    document.head.appendChild(link)
  })
}
